// Module
var code = "<div class=\"b-tooltip\"></div> ";
// Exports
module.exports = code;